import { render, staticRenderFns } from "./partnerOrders.vue?vue&type=template&id=700dcd66&scoped=true"
import script from "./partnerOrders.vue?vue&type=script&lang=js"
export * from "./partnerOrders.vue?vue&type=script&lang=js"
import style0 from "./partnerOrders.vue?vue&type=style&index=0&id=700dcd66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700dcd66",
  null
  
)

export default component.exports